import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import PipelineLicenseGate from "@/components/PipelineLicenseGate";
import ScrollToTop from "@/components/ScrollToTop";
import HomePage from "@/pages/HomePage";
import ProductsPage from "@/pages/ProductsPage";
import SettingsPage from "@/pages/SettingsPage";
import LanguagePage from "@/pages/LanguagePage";
import ProfilePage from "@/pages/ProfilePage";
import ChangePasswordPage from "@/pages/ChangePasswordPage";
import PipelineStudioPage from "@/pages/PipelineStudioPage";
import PlansPage from "@/pages/PlansPage";
import LoginPage from "@/pages/LoginPage";
import NotFoundPage from "@/pages/NotFoundPage";
import PlatformUsersPage from "@/pages/PlatformUsersPage";
import UserRequestsPage from "@/pages/UserRequestsPage";
import ProjectsPage from "@/pages/ProjectsPage";
import ProjectInformationPage from "@/pages/ProjectInformationPage";
import ProjectMembersPage from "@/pages/ProjectMembersPage";
import ProjectRequestsPage from "@/pages/ProjectRequestsPage";
import ProjectPipelineStudioPage from "@/pages/ProjectPipelineStudioPage";
import ProjectCreateFlowPage from "@/pages/ProjectCreateFlowPage";
import ProjectPipelineStudioDetailPage from "@/pages/ProjectPipelineStudioDetailPage";
import ProjectProductsPage from "@/pages/ProjectProductsPage";

export default function AppRouter() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout>
                <HomePage />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/projects"
          element={
            <ProtectedRoute>
              <Layout>
                <ProjectsPage />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/projects/:projectId/information"
          element={
            <ProtectedRoute>
              <ProjectInformationPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/projects/:projectId/members"
          element={
            <ProtectedRoute>
              <ProjectMembersPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/projects/:projectId/requests"
          element={
            <ProtectedRoute>
              <ProjectRequestsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/projects/:projectId/products"
          element={
            <ProtectedRoute>
              <ProjectProductsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/projects/:projectId/products/pipeline-studio"
          element={
            <ProtectedRoute>
              <PipelineLicenseGate>
                <ProjectPipelineStudioPage />
              </PipelineLicenseGate>
            </ProtectedRoute>
          }
        />
        <Route
          path="/projects/:projectId/products/pipeline-studio/create"
          element={
            <ProtectedRoute>
              <PipelineLicenseGate>
                <ProjectCreateFlowPage />
              </PipelineLicenseGate>
            </ProtectedRoute>
          }
        />
        <Route
          path="/projects/:projectId/products/pipeline-studio/:namespace/:name"
          element={
            <ProtectedRoute>
              <PipelineLicenseGate>
                <ProjectPipelineStudioDetailPage />
              </PipelineLicenseGate>
            </ProtectedRoute>
          }
        />
        <Route
          path="/products"
          element={
            <ProtectedRoute>
              <Layout>
                <ProductsPage />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/products/pipeline-studio"
          element={
            <ProtectedRoute>
              <PipelineLicenseGate>
                <Layout>
                  <PipelineStudioPage />
                </Layout>
              </PipelineLicenseGate>
            </ProtectedRoute>
          }
        />
        <Route
          path="/plans"
          element={
            <ProtectedRoute>
              <Layout>
                <PlansPage />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/platform-users"
          element={
            <ProtectedRoute>
              <Layout>
                <PlatformUsersPage />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/user-requests"
          element={
            <ProtectedRoute>
              <Layout>
                <UserRequestsPage />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings/language"
          element={
            <ProtectedRoute>
              <Layout>
                <LanguagePage />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings/profile"
          element={
            <ProtectedRoute>
              <Layout>
                <ProfilePage />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings/password"
          element={
            <ProtectedRoute>
              <Layout>
                <ChangePasswordPage />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <Layout>
                <SettingsPage />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings/:tab"
          element={
            <ProtectedRoute>
              <Layout>
                <SettingsPage />
              </Layout>
            </ProtectedRoute>
          }
        />
        {/* 404 - Catch all unmatched routes */}
        <Route
          path="*"
          element={
            <ProtectedRoute>
              <Layout>
                <NotFoundPage />
              </Layout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
